import {
    GRUPOTECNICO_LIST,
    GRUPOTECNICO_FULLLIST,
    GRUPOTECNICO_LISTA,
    GRUPOTECNICO_FILTER,
    GRUPOTECNICO_CREATE,
    GRUPOTECNICO_UPDATE,
    GRUPOTECNICO_UPDATE_SUCCESS,
    GRUPOTECNICO_CREATE_SUCCESS,
    GRUPOTECNICO_LIST_SUCCESS,
    GRUPOTECNICO_FULLLIST_SUCCESS,
    GRUPOTECNICO_REQUEST_FAILED,
    GRUPOTECNICO_READ,
    GRUPOTECNICO_READ_SUCCESS,
    GRUPOTECNICO_DELETE,
    GRUPOTECNICO_DELETE_SUCCESS
  } from "./actionTypes";
  
  export const grupotecnicoList = () => {
    return {
      type: GRUPOTECNICO_LIST,
      payload: {},
    };
  };
  export const grupotecnicoFullList = () => {
    return {
      type: GRUPOTECNICO_FULLLIST,
      payload: {},
    };
  };
  export const grupotecnicoLista = () => {
    return {
      type: GRUPOTECNICO_LISTA,
      payload: {},
    };
  };
  
  export const grupotecnicoCreate = (grupotecnico) => {
    return {
      type: GRUPOTECNICO_CREATE,
      payload: grupotecnico,
    };
  };
  
  export const grupotecnicoFilter = (changeUrl) => {
    return {
      type: GRUPOTECNICO_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const grupotecnicoRead = (id) => {
    return {
      type: GRUPOTECNICO_READ,
      payload: {id},
    };
  };

  export const grupotecnicoReadSuccess = (data) => {
    return {
      type: GRUPOTECNICO_READ_SUCCESS,
      payload: data,
    };
  };
  
  export const grupotecnicoUpdate = (id, data) => {
    return {
      type: GRUPOTECNICO_UPDATE,
      payload: { id, data },
    };
  };
  export const grupotecnicoDelete = (id) => {
    return {
      type: GRUPOTECNICO_DELETE,
      payload: { id },
    };
  };
  
  export const grupotecnicoListSuccess = (grupotecnico) => {
    return {
      type: GRUPOTECNICO_LIST_SUCCESS,
      payload: grupotecnico,
    };
  };
  export const grupotecnicoFullListSuccess = (grupotecnico) => {
    return {
      type: GRUPOTECNICO_FULLLIST_SUCCESS,
      payload: grupotecnico,
    };
  };
  
  export const grupotecnicoCreateSuccess = (grupotecnicoCreated) => {
    return {
      type: GRUPOTECNICO_CREATE_SUCCESS,
      payload: grupotecnicoCreated,
    };
  };
  
  export const grupotecnicoUpdateSuccess = (grupotecnico) => {
    return {
      type: GRUPOTECNICO_UPDATE_SUCCESS,
      payload: grupotecnico,
    };
  };
  export const grupotecnicoDeleteSuccess = (grupotecnico) => {
    return {
      type: GRUPOTECNICO_DELETE_SUCCESS,
      payload: grupotecnico,
    };
  };
  
  export const grupotecnicoRequestFailed = (error) => {
    return {
      type: GRUPOTECNICO_REQUEST_FAILED,
      payload: error,
    };
  };
  